<template>
    <div class="text">
        <label class="required" for="ss">
            S<sub>s</sub>
        </label>        
        <input
            type="number"
            key="ss-input"
            :value="value"
            v-on:change="$emit('change', $event.target.value)"
            placeholder="Enter your Ss value"  
            min="0" 
            max="4.5" 
            step=".1" 
            required 
        />
        <p class="error simple" v-if="error" v-html="error"></p>
        <p class="note">
            Refer to the <a href="https://asce7hazardtool.online/">ASCE 7 Hazard Tool</a>
        </p>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {type: [String, Number]},
        error: {type: [String]},
    },
}
</script>